import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './locales/en/translation.json'
import es from './locales/es/translation.json'
import pt from './locales/pt/translation.json'
import ko from './locales/ko/translation.json'
import ja from './locales/ja/translation.json'
import hi from './locales/hi/translation.json'
import de from './locales/de/translation.json'
import fr from './locales/fr/translation.json'
import it from './locales/it/translation.json'
import ru from './locales/ru/translation.json'

const resources = {
    en: { translation: en },
    es: { translation: es },
    pt: { translation: pt },
    ko: { translation: ko },
    ja: { translation: ja },
    hi: { translation: hi },
    de: { translation: de },
    fr: { translation: fr },
    it: { translation: it },
    ru: { translation: ru },
}

// NOTE: user language detection is done in `useI18nLanguageActions`.

i18n
    // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
    // learn more: https://github.com/i18next/i18next-http-backend
    // want your translations to be loaded from a professional CDN? => https://github.com/locize/react-tutorial#step-2---use-the-locize-cdn
    // .use(Backend)
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        resources: resources,

        lgn: 'en',
        fallbackLng: 'en',
        debug: false,

        defaultNS: 'translation',
        keySeparator: false, // important for using full sentences as keys

        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
    })

export default i18n
